import { isEmpty, isFormValid, setError, syncProfileMarker } from '../../../../library/Core/SmartFunctions';
import { ControlOnChangeArguments, DispatchEvent, State } from '../../../../library/Core/SmartTypes';
import { AlumniProfileEditScreens } from '../../../../services/screen-navigation.service';
import StudentService from '../../../../services/student.service';
import { navigateToNextStep } from '../../services/profile-next-step-navigator';
import axios from 'axios';

export const handleNext = (
    event: React.SyntheticEvent<HTMLButtonElement>,
    state: State,
    dispatch: (dispatchEvent: DispatchEvent) => void,
    globalState: any,
    globalDispatch: (dispatchEvent: DispatchEvent) => void,
    sessionState: any,
    sessionDispatch: (dispatchEvent: DispatchEvent) => void
) => {
    event.preventDefault();

    const inValidDate = isValidDate(state, dispatch);
    const isImpersonatedSession = sessionStorage.getItem('is-impersonated-session') === 'YES';
    const customValidationPassed = isFormValidBasedOnCustomValidation(state, dispatch);

    if (!isImpersonatedSession && (!isFormValid(state, dispatch, ['jobsApplied.*.companyId', 'jobOutcome.companyId']) || !customValidationPassed || !inValidDate)) {
        dispatch({ type: 'SHOW_ERRORS' });
        return;
    }

    let jobOutcome = Array.isArray(state?.data['jobOutcome']) ? state?.data['jobOutcome'] : [state?.data['jobOutcome']];
    jobOutcome = jobOutcome.map((job) => {
        const existingJob = state?.data?.jobsList?.find((existingJob: any) => existingJob.id == job.id);
        const updatedJob = {
            ...existingJob,
            ...job,
            recordTypeCode: existingJob?.recordTypeCode || 'JOINED',
            isOutcome: 1,
            jobCategory: 'WORKING_FOR_A_COMPANY',
            // endDate: job.isCurrent ? null : existingJob?.endDate,
            endDate: job.isCurrent === true ? null : (job?.endDate ?? existingJob?.endDate ?? null),
        };
        return updatedJob;
    });

    const jobsNotInOutcome = state?.data?.jobsList?.filter((existingJob: any) => !jobOutcome.some((job: any) => job.id === existingJob.id));
    jobOutcome = [...jobOutcome, ...jobsNotInOutcome];

    const appliedForThePlacement = state?.data['jobOutcome'].isCampusPlacement === false ? false : state?.data['profile'].appliedForThePlacement;
    const profile = { ...state?.data['profile'], appliedForThePlacement };

    const jobsApplied = handleJobsApplied(appliedForThePlacement, state?.data['jobsApplied'], state?.data?.jobsList, true);
    let jobHistory = [...jobOutcome, ...jobsApplied];

    jobHistory = jobHistory.map((job: any) => ({
        ...job,
        countryCode: (job.isRemotelyWorking ? state?.data?.profile?.residingCountryCode : job.countryCode)?.trim() || null,
        cityCode: (job.isRemotelyWorking ? state?.data?.profile?.residingCityCode : job.cityCode)?.trim() || null
    }));

    StudentService.pageSave(
        state.routeInfo.id,
        state.routeInfo.pageName,
        StudentService.toStudentEntity({ id: state.routeInfo.id, jobs: jobHistory, profile })
    ).then((response) => {
        if (response?.status === 200) {
            sendMoEngageEvent(state?.data);
            syncProfileMarker(state.routeInfo.id).then(() => {
                navigateToNextStep(AlumniProfileEditScreens.WORK_DETAILS, state, dispatch, sessionState, sessionDispatch);
            });
        }
    });
};

const handleJobsApplied = (appliedForThePlacement: any, jobsApplied: any[], existingJobs: any[], isOutcome: boolean) => {
    if (appliedForThePlacement) {
        return jobsApplied.map((job: any) => {
            const existingJob = existingJobs.find((existingJob: any) => existingJob.id === job.id);
            if (existingJob) {
                return {
                    ...existingJob,
                    ...job, 
                    isOutcome: isOutcome, 
                };
            } else {
                return {
                    ...job,
                    isOutcome: isOutcome,
                };
            }
        });
    }
    return [];
};

const isFormValidBasedOnCustomValidation = (state: State, dispatch: (dispatchEvent: DispatchEvent) => void) => {
    const errorMessages = [] as any[];
    let isFormInvalid = false;
    const jobs = state.data.jobsApplied;
    const jobOutcome = state.data.jobOutcome;

    if (isEmpty(jobOutcome?.companyId) && isEmpty(jobOutcome?.otherCompany)) {
        isFormInvalid = true;
        setError(`jobOutcome.companyId`, [`Please enter "Which company did you join?"`], dispatch);
    } else {
        setError(`jobOutcome.companyId`, [], dispatch);
    }

    const appliedForThePlacement = jobOutcome.isCampusPlacement === false ? false : state?.data['profile']?.appliedForThePlacement;
    if(appliedForThePlacement){
        jobs.forEach((job: any, index: number) => {
            if (isEmpty(job?.companyId) && isEmpty(job?.otherCompany)) {
                isFormInvalid = true;
                setError(`jobsApplied.${index}.companyId`, [`Please enter "Name of the Company"`], dispatch);
            } else {
                setError(`jobsApplied.${index}.companyId`, [], dispatch);
            }
        });
    }

    // Dispatch the validation errors to the state
    if ( isFormInvalid ) {
        dispatch({
            type: 'SET_FIELD_VALIDATION_ERRORS',
            payload: { dataKey: 'jobsApplied', errorMessages },
        });
        
        dispatch({
            type: 'SET_FIELD_VALIDATION_ERRORS',
            payload: { dataKey: 'jobOutcome', errorMessages },
        });
    }
    
    return !isFormInvalid;
};


export const onCurrentJobSelectionChange = (props: ControlOnChangeArguments) => {
    const rowIndex = parseInt(props.parentDataKey.split('.').pop() as string);
    const jobs = props.state.data.jobs.map((row: any, index: number) => {
        return index == rowIndex ? { ...row, endYear: '', isCurrent: false } : { ...row, isCurrent: false };
    });

    props.dispatch({ type: 'SET_FIELD_VALIDATION_ERRORS', payload: { dataKey: `${props.parentDataKey}.jobStartAndEndDates`, value: [] } });

    props.dispatch({ type: 'CONTROL_VALUE_CHANGE', payload: { dataKey: 'jobs', value: jobs } });
};

export const handleCompleteLater = (state: State, dispatch: (dispatchEvent: DispatchEvent) => void) => {
    document.getElementsByClassName('modal').item(0)?.setAttribute('style', 'display:block');
};

const isValidDate = (state: State, dispatch: (dispatchEvent: DispatchEvent) => void) => {
    const job = state?.data['jobOutcome'];
    let isFormValid = true;
    
        console.log(job);

        if (isEmpty(job?.startDate)) {
            setError(`jobOutcome.startDate`, [`Please enter "Start Date" `], dispatch);
            isFormValid = false;
        } else {
            setError(`jobOutcome.startDate`, [], dispatch);
        }

        if ((job?.isCurrent === false || isEmpty(job?.isCurrent)) && isEmpty(job?.endDate)) {
            setError(`jobOutcome.endDate`, [`Please enter "End Date" `], dispatch);
            isFormValid = false;
        } else {
            setError(`jobOutcome.endDate`, [], dispatch);
        }

        if (job?.isCurrent === false || isEmpty(job?.isCurrent)) {
            if (new Date(job?.startDate) > new Date(job?.endDate)) {
                setError(`jobOutcome.endDate`, [`End year should be greater than or equal to Start year`], dispatch);
                isFormValid = false;
            } else {
                setError(`jobOutcome.endDate`, [], dispatch);
            }
        }

    return isFormValid;
};

const sendMoEngageEvent = async (user: any) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_MOENGAGE_API}/moengage/moengage-job-outcome`, {
            userInfo: user,
        });
    } catch (error) {
        console.error('Error fetching data:', error);
    }
    return false;
};
